export type PlanningBoardRosterMembership = {
  teamId: string;
  playerId: string;
  isActive?: boolean | null;
  rosterStatus?: string | null;
};

/** Returns canonical player IDs on every selected team's current active roster. */
export function playersRosteredOnAllSelectedTeams(
  selectedTeamIds: string[],
  memberships: PlanningBoardRosterMembership[],
): string[] {
  const teamIds = [...new Set(selectedTeamIds)].filter(Boolean);
  if (!teamIds.length) return [];
  const playersByTeam = new Map<string, Set<string>>();
  memberships.forEach((membership) => {
    if (!teamIds.includes(membership.teamId)) return;
    if (membership.isActive === false || membership.rosterStatus === 'inactive') return;
    const players = playersByTeam.get(membership.teamId) || new Set<string>();
    players.add(membership.playerId);
    playersByTeam.set(membership.teamId, players);
  });
  const firstTeamPlayers = playersByTeam.get(teamIds[0]) || new Set<string>();
  return [...firstTeamPlayers].filter((playerId) => teamIds.every((teamId) => playersByTeam.get(teamId)?.has(playerId)));
}

/** Returns canonical player IDs on at least one selected team's current active roster. */
export function playersRosteredOnAnySelectedTeam(
  selectedTeamIds: string[],
  memberships: PlanningBoardRosterMembership[],
): string[] {
  const teamIds = new Set(selectedTeamIds.filter(Boolean));
  if (teamIds.size === 0) return [];
  const playerIds = new Set<string>();
  memberships.forEach((membership) => {
    if (!teamIds.has(membership.teamId)) return;
    if (membership.isActive === false || membership.rosterStatus === 'inactive') return;
    playerIds.add(membership.playerId);
  });
  return [...playerIds];
}
